module.exports = __webpack_public_path__ + "img/company.ff3b3365.png";